import { MutationTree } from 'vuex';
import { SubsidyState } from '../types';
import Vue from 'vue';

export const mutations: MutationTree<SubsidyState> = {
	SET_SUBSIDIES(state: SubsidyState, subsidies: Subsidy[]) {
		Vue.set(state, 'subsidies', subsidies);
	}
};